import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";

import { FormToolsService, MainConfig } from "@atenea-cms";
import { ColorValidator } from "@atenea-cms";
import { AbstractControl } from "@angular/forms/src/model";

import { has } from "lodash";

@Component({
  selector: "slide-form",
  templateUrl: "./slide-form.component.html",
  styleUrls: ["./slide-form.component.scss"],
})
export class SlideFormComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() formService: any;
  @Input() productSheet?: boolean = null;

  defaultPositions: Array<Object> = [];
  backgroundPositions: Array<Object> = [];
  backgroundPatternAligments: Array<Object> = [];
  backgroundPatternStyles: Array<Object> = [];
  heightOptions: Array<Object> = [];
  textColorOptions: Array<Object> = [];
  textBackgroundOptions: Array<Object> = [];
  backgroundColorOptions: Array<Object> = [];
  actionsAlign: Array<Object> = [];
  config: any = {};

  constructor(public ft: FormToolsService, public mainConfig: MainConfig) {
    this.config = this.mainConfig.modules.common;

    this.defaultPositions = [
      { value: "top", label: "Arriba" },
      { value: "bottom", label: "Abajo" },
      { value: "left", label: "Izquierda" },
      { value: "right", label: "Derecha" },
      { value: "center", label: "Centro" },
    ];

    this.backgroundPositions = [
      { value: "top", label: "Arriba" },
      { value: "bottom", label: "Abajo" },
      { value: "left", label: "Izquierda" },
      { value: "right", label: "Derecha" },
      { value: "center", label: "Centro" },
    ];

    this.backgroundPatternAligments = [
      { value: "none", label: "Ninguno" },
      { value: "left", label: "Izquierda" },
      { value: "center", label: "Centro" },
      { value: "right", label: "Derecha" },
      { value: "full", label: "Completo" },
    ];

    this.backgroundPatternStyles = [
      { value: "light", label: "Claro" },
      { value: "dark", label: "Oscuro" },
    ];

    this.heightOptions = [
      { value: "auto", label: "Automática" },
      { value: "viewport", label: "Viewport" },
    ];

    this.textColorOptions = [
      { value: "light", label: "Claro" },
      { value: "dark", label: "Oscuro" },
    ];

    // Fondo del texto
    if (has(this.config, "slide.textBackground.options")) {
      this.textBackgroundOptions = this.config.slide.textBackground.options;
    } else {
      this.textBackgroundOptions = [
        { value: "none", label: "Ninguno" },
        { value: "light", label: "Claro" },
        { value: "dark", label: "Oscuro" },
      ];
    }
    // Colores de fondo
    if (this.config) {
      this.backgroundColorOptions = this.config.slide.backgroundColorOptions;
    } else {
      this.backgroundColorOptions = [
        { value: "white", label: "Blanco" },
        { value: "light", label: "Claro" },
        { value: "dark", label: "Oscuro" },
        { value: "black", label: "Negro" },
        { value: "custom", label: "Personalizado" },
      ];
    }

    this.actionsAlign = [
      { value: "left", label: "Izquierda" },
      { value: "right", label: "Derecha" },
      { value: "center", label: "Centro" },
    ];
  }

  ngOnInit(): void {
    const backgroundColorAlias: AbstractControl = this.form.get(
      "backgroundColorAlias"
    );

    backgroundColorAlias.valueChanges.subscribe(
      this.backgroundColorAliasChange.bind(this)
    );
    this.backgroundColorAliasChange(backgroundColorAlias.value);
  }

  backgroundColorAliasChange(alias: string): void {
    const controlPrimary: AbstractControl = this.form.get("backgroundColor");
    const controlSecondary: AbstractControl = this.form.get(
      "backgroundColorSecondary"
    );

    if (alias === "custom") {
      controlPrimary.setValidators([Validators.required, ColorValidator]);
      controlSecondary.setValidators([Validators.required, ColorValidator]);
    } else {
      controlPrimary.clearValidators();
      controlSecondary.clearValidators();
    }

    controlPrimary.updateValueAndValidity();
    controlSecondary.updateValueAndValidity();
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/common/components/slide-form/slide-form.component.ts